var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconM48Filled = function SvgIconM48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm1.32 20.62c-.64.79-1.99.79-2.64 0l-3.48-4.29v7.21h-3.4v-12c0-.72.45-1.36 1.13-1.6.68-.24 1.43-.03 1.89.53L24 24.15l5.18-6.38a1.7 1.7 0 0 1 3.02 1.07v12h-3.4v-7.21l-3.48 4.28v.01Z",
    fill: "current"
  })));
};
export default SvgIconM48Filled;